// "Pick your address" (Royal Mail PAF), its own small script: the layout and
// the admin manual-order form add it only while ADDRESS_LOOKUP_PROVIDER is
// on, so gwmc.js does not grow (docs/ADDRESS_LOOKUP.md).
import { installAddressPick } from '../gwmc/components/address-pick/index.js'

installAddressPick()
